import { B2cBrand, B2cCategory } from "@/generated/graphql/b2c";
import { t } from "i18next";

export type MinimalB2cCategory = Pick<B2cCategory, 'id' | 'name'>;
export type MinimalB2cBrand = Pick<B2cBrand, 'id' | 'name'>;

export type Option = {
    name: string;
    key: string;
    _search: string;
};

export const normalizeSearch = (search: string): string => {
    return search.toLowerCase().trim();
};

export const addType = (type: string, id: string) => `${type}:${id}`;
export const hasType = (type: string, key: string) => key.startsWith(`${type}:`);
export const removeType = (type: string, key: string) => key.replace(`${type}:`, '');

export const filterOptions = (list: Option[], searchText?: null | string): Option[] => {
    const search = normalizeSearch(searchText || '');

    return list.filter(item => {
        return search.length === 0 || item._search.includes(search);
    });
};

export const createCategoryOptions = (categories: MinimalB2cCategory[]): Option[] => {
    return categories.map((category) => ({
        name: category.name,
        key: addType('categories', category.id),
        _search: normalizeSearch(category.name)
    }));
};

export const createBrandOptions = (brands: MinimalB2cBrand[]): Option[] => {
    return brands.map((brand) => ({
        name: brand.name,
        key: addType('brands', brand.id),
        _search: normalizeSearch(brand.name)
    }));
};

export const createSorterOptions = (): Option[] => {
    return [
        { key: "price.asc", name: t("ro3ggi8y7n19ytkt.sort-by-price-asc", "Price: Low to High") },
        { key: "price.desc", name: t("ro3ggi8y7n19ytkt.sort-by-price-desc", "Price: High to Low") },
        { key: "dispatch.asc", name: t("ro3ggi8y7n19ytkt.sort-by-dispatch-asc", "Dispatch: Low to High") },
        { key: "dispatch.desc", name: t("ro3ggi8y7n19ytkt.sort-by-dispatch-desc", "Dispatch: High to Low") },
    ].map(item => ({
        ...item,
        _search: normalizeSearch(item.name)
    }));
};